import cx from 'classnames'
import { type ReactNode } from 'react'

import Icon, { IconName } from '@components/icon'

interface FooterLinkProps {
  id: string
  children: ReactNode
  href?: string
  icon?: IconName
}

const FooterLink = ({ id, children, href, icon }: FooterLinkProps) => {
  return (
    <a
      href={href}
      className={cx('inline-flex items-start gap-x-2.5 text-base group', {
        'pointer-events-none': !href,
      })}
    >
      {!!icon && (
        <span className="bg-white bg-opacity-[0.05] rounded-full p-2 text-xl">
          <Icon id={id} name={icon} />
        </span>
      )}

      <span className="mt-1 group-hover:opacity-60 transition-opacity duration-200">
        {children}
      </span>
    </a>
  )
}

export default FooterLink
